module.exports = __webpack_public_path__ + "f5ac5570fa0bb3504b86f2afd17a053e.png";